import { render, staticRenderFns } from "./TerminPublicView.vue?vue&type=template&id=5a6b96bb&scoped=true"
import script from "./TerminPublicView.vue?vue&type=script&lang=js"
export * from "./TerminPublicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b96bb",
  null
  
)

export default component.exports